import certificationsService from '../../services/certificationsService'

const createCertificationsSlice = (set, get) => ({
  certifications: [],
  setCertifications: (items) => set({ certifications: items }),
  addCertification: (item) =>
    set((state) => ({ certifications: [{ ...item, id: item.id ?? Date.now().toString() }, ...state.certifications] })),
  updateCertificationLocal: (id, patch) =>
    set((state) => ({ certifications: state.certifications.map((e) => (e.id === id ? { ...e, ...patch } : e)) })),
  removeCertification: (id) => set((state) => ({ certifications: state.certifications.filter((e) => e.id !== id) })),
  clearCertifications: () => set({ certifications: [] }),

  fetchCertificationsRemote: async () => {
    try {
      const res = await certificationsService.listCertifications()
      const data = Array.isArray(res) ? res : (res && res.data) || []
      set({ certifications: data.reverse() })
      return { success: true, data }
    } catch (err) {
      return { success: false, error: err }
    }
  },

  createCertificationRemote: async (payload) => {
    try {
      await certificationsService.createCertification(payload)
      await get().fetchCertificationsRemote()
      return { success: true }
    } catch (err) {
      return { success: false, error: err }
    }
  },

  updateCertificationRemote: async (payload) => {
    try {
      await certificationsService.updateCertification(payload)
      await get().fetchCertificationsRemote()
      return { success: true }
    } catch (err) {
      return { success: false, error: err }
    }
  },

  deleteCertificationRemote: async (id) => {
    try {
      await certificationsService.deleteCertification(id)
      await get().fetchCertificationsRemote()
      return { success: true }
    } catch (err) {
      return { success: false, error: err }
    }
  },
})

export default createCertificationsSlice
